<section class="content-container">
  <div class="content-animation-wrapper" [@routeTransition]="getAnimation()">
    <router-outlet #appOutlet="outlet"></router-outlet>
  </div>
</section>

<div class="offline" *ngIf="!isOnline">Data not synced, currently offline.</div>
